module.exports = __webpack_public_path__ + "media/landing-page/dhl-bubble-b088ce99.png";